import Vue from 'vue'

Vue.prototype.$coinDefaultSrc = (symbol) => {
  if (symbol === 'WEB_MONEY') {
    return 'https://cdn.arzypto.com/images/coins/WM.png'
  } else if (symbol === 'PERFECT_MONEY' || symbol === 'VOUCHER') {
    return 'https://cdn.arzypto.com/images/coins/PM.png'
  } else if (symbol === 'PAYEER') {
    return 'https://cdn.arzypto.com/images/coins/PAYEER.png'
  }
  return 'https://cdn.arzypto.com/images/coin_logo/' + symbol + '.png'
}

Vue.prototype.$imgPlaceholder = (e) => {
  e.target.src = 'https://cdn.arzypto.com/images/logo/arzypto-og-image.png'
}
